// extracted by mini-css-extract-plugin
export var item = "Item-module--item--5gne9";
export var item__imageWrap = "Item-module--item__imageWrap--ygEPI";
export var item__imageWrap__tooltip = "Item-module--item__imageWrap__tooltip--az-F6";
export var item__imageWrap__tooltip__text = "Item-module--item__imageWrap__tooltip__text--9giBg";
export var item__subTitle = "Item-module--item__subTitle--3rXAe";